
import { authHeader } from '../_helpers';
import request from '../_helpers/request';

export const PRODUCT_DISPLAY_STATUS = {
  toBeSubmitted: 'toBeSubmitted',
  pending: 'pending',
  pendingManualAudit: 'pendingManualAudit',
  live: 'live',
  rejected: 'rejected',
};

export const PRODUCT_LAUNCH_STATUS = {
  online: 'online',
  offline: 'offline',
};

/** Review Status → i18n key（对齐 Figma 列表：Activated / Syncing / Manual Review / Not Submitted） */
export const PRODUCT_REVIEW_STATUS_I18N = {
  toBeSubmitted: 'lbl_EMPBE_Product_NotSubmitted',
  pending: 'lbl_EMPBE_Ad_Status_Pending',
  pendingManualAudit: 'lbl_EMPBE_Ad_Status_PendingManualAudit',
  live: 'lbl_EMPBE_Product_Approved',
  rejected: 'lbl_EMPBE_Rejected',
};

export const productService = {
  GetMainProductCountAsync,
  //列表
  getProdutListAsync,
  getProdutCatalogListAsync,
  GetProducWithImage,
  //展品介绍
  getProdutDetailAsync,
  createProdutDetailIndex,
  saveProdutDetailIndex,
  saveProdutCatalogDetail,
  submitProdutCatalogDetail,
  saveProdutCatalogDetailIndex,
  deleteProdutCatalogDetail,

  // 产品目录
  getExhibitCatalogById,
  //热搜标签
  GetMstTag,
  GetMstKeyValueMapping,
  GetMutipleMstKeyValueMapping,
  //国家/省/市
  GetCountryProvCityArea,
  //保存
  saveProdutAsync,
  getTempCompanyExhibitDetails,
  //删除
  deleteCompanyExhibitDetails,
  //提交到真实表
  submitProdutAsync,
  //获取用户其他信息
  GetOtherInfo,
  //检查 购买的数量 和 可用数量
  getSysAccountPaymentInfo,
  //检查 购买的数量 和 上架数量
  checkSysAccountPaymentInfo,
  //显示用户可用广告类型和数量
  getSysAccountAdInfo,
  GetProductMainProdCount,
  //根据公司id获取 应用行业
  GetIndustryByCompanyId,
  //根据公司id获取 产品类别
  GetProductCatByCompanyId,
  //修改是否主打产品
  UpdateProductMainProd,
  //檢查product 有沒有ad linkage
  CheckProductBeforeDelete,
  //更新廣告的搜尋關鍵字(Cat/App/Keyword)
  UpdateAdsDisplay,
  //Get Product Keyword
  GetAdSearchKeyword,
  //Submit Visitor Guide
  SumbitVisitorGuide,
  //Get User's visitor guide
  GetUserVisitorGuie,
  //#region  新产品中新api
  GetProductBasicInfo,
  SaveProductBasicInfo,
  GetProductInfoStatus,
  GetCatalogueBuyDownloads,
  GetProductInfoProgress,
  GetProductInToFiledList,
  GetPricingAndTradeInfo,
  GetProductDetail,
  GetProductTag,
  SavePricingAndTradeInfo,
  SaveProductDetail,
  SaveProductTag,
  DelistProduct,
  //产品目录下架
  DelistProductCatalog,
  GetProductList,
  GetProductCatalogueById,
  SaveSubmitCatalogue,
  SaveCatalogue, 
  CatalogueDelete, 
  ProductDelete,
  BatchProductAction,
  SubmitProductInfo,
  //同步产品到前端
  SyncProductToFrontEnd,
  //产品审核（供应商详情页用）
  GetProductApprovalStatus,
  GetProductApprovalQuotaUsage,
  GetProductApprovalDetail,
  UpdateProductRejectReason,
  UpdateProductOverallRejectReason,
  ProductApprove,
  //#endregion
};

/** 产品审核状态映射（对齐广告机制；产品无有效期，A = live） */
export function resolveProductRowStatus(product) {
  const code = product?.statusCode
    ?? product?.StatusCode
    ?? product?.approvalStatusCode
    ?? product?.ApprovalStatusCode;
  if (code === 'A') return PRODUCT_DISPLAY_STATUS.live;
  if (code === 'PA') return PRODUCT_DISPLAY_STATUS.pendingManualAudit;
  if (code === 'P') return PRODUCT_DISPLAY_STATUS.pending;
  if (code === 'R') return PRODUCT_DISPLAY_STATUS.rejected;
  if (code === 'N' || code === '' || code == null) return PRODUCT_DISPLAY_STATUS.toBeSubmitted;
  return PRODUCT_DISPLAY_STATUS.toBeSubmitted;
}

/**
 * 是否占用产品配额：展示状态(上下架) + 提交状态联合判断
 * 上线：已审批/审批中/人工审批中/已驳回 均占
 * 下线：仅审批中/人工审批中 占；未提交/已审批/已驳回 不占
 */
export function productOccupiesApprovalQuota(product) {
  const status = resolveProductRowStatus(product);
  const isOnline = resolveProductLaunchStatus(product) === PRODUCT_LAUNCH_STATUS.online;
  if (status === PRODUCT_DISPLAY_STATUS.pending
    || status === PRODUCT_DISPLAY_STATUS.pendingManualAudit) {
    return true;
  }
  if (isOnline && (status === PRODUCT_DISPLAY_STATUS.live
    || status === PRODUCT_DISPLAY_STATUS.rejected)) {
    return true;
  }
  return false;
}

/**
 * Products Status：仅由上下架动作控制（isLaunch），不受审核状态流转影响
 * @returns {'online'|'offline'}
 */
export function resolveProductLaunchStatus(product) {
  const isLaunch = product?.isLaunch === true
    || product?.isLaunch === 1
    || product?.IsLaunch === true
    || product?.IsLaunch === 1;
  return isLaunch ? PRODUCT_LAUNCH_STATUS.online : PRODUCT_LAUNCH_STATUS.offline;
}

/** Review Status display key（toBeSubmitted / pending / ...） */
export function resolveProductReviewStatus(product) {
  return resolveProductRowStatus(product);
}

/** 可编辑/可重新提交（对齐广告 isAdDraftStatus：空/N/R） */
export function isProductDraftStatus(statusCode) {
  const code = statusCode == null ? '' : String(statusCode).trim();
  return code === '' || code === 'N' || code === 'R';
}

/** 详情页「保存」：对齐广告 canShowAdSaveButton，各审核状态均显示 */
export function canShowProductSaveButton(displayStatus) {
  void displayStatus;
  return true;
}

export function parseProductDateMs(value) {
  if (value == null || value === '' || value === '-') return null;
  const raw = String(value).trim();
  if (!raw || raw.startsWith('0001-01-01') || raw.startsWith('1900-01-01')) return null;
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const ms = Date.parse(normalized);
  return Number.isNaN(ms) ? null : ms;
}

/** 列表/详情草稿标识：已提交过且有新草稿时显示（未提交不显示）——对齐广告 hasAdListDraftIndicator */
export function hasProductListDraftIndicator(row) {
  if (!row) return false;
  if (row.displayStatus === PRODUCT_DISPLAY_STATUS.toBeSubmitted) return false;
  const saveMs = parseProductDateMs(row.lastSaveDate);
  const submitMs = parseProductDateMs(row.lastSubmitDate);
  if (saveMs == null || submitMs == null) return false;
  return saveMs > submitMs;
}

export function GetMainProductCountAsync(query) {
  return request({
    url: 'Product/GetMainProductCountAsync',
    method: 'get',
    params: query
  });
}
export function getProdutListAsync(query) {
  const params = Object.assign({}, query || {});
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === '') {
      delete params[key];
    }
  });
  return request({
    url: 'Product/GetCompanyExhibitListByCompId',
    method: 'get',
    params
  });
}

/** 兼容分页对象 { items, totalCount, onlineCount } 与旧版数组返回 */
export function unwrapProductListPayload(data) {
  if (Array.isArray(data)) {
    return {
      items: data,
      totalCount: data.length,
      onlineCount: null,
      unsubmittedCount: null,
      pendingManualAuditCount: null,
      rejectedCount: null,
      occupiedCount: null,
    };
  }
  const payload = data || {};
  const items = payload.items || payload.Items || [];
  return {
    items: Array.isArray(items) ? items : [],
    totalCount: payload.totalCount ?? payload.TotalCount ?? 0,
    onlineCount: payload.onlineCount ?? payload.OnlineCount ?? null,
    unsubmittedCount: payload.unsubmittedCount ?? payload.UnsubmittedCount ?? null,
    pendingManualAuditCount: payload.pendingManualAuditCount ?? payload.PendingManualAuditCount ?? null,
    rejectedCount: payload.rejectedCount ?? payload.RejectedCount ?? null,
    occupiedCount: payload.occupiedCount ?? payload.OccupiedCount ?? null,
  };
}
function getProdutCatalogListAsync(query) {
  return request({
    // url: 'Product/GetExhibitCatalogListAsync',
     url: 'Product/GetExhibitCatalogListByCompId',
    method: 'get',
    params: query
  });
}
function getProdutDetailAsync(query) {
  return request({
    url: 'Product/GetCompanyExhibitByIdAsync',
    method: 'get',
    params: query
  });

}
function saveProdutDetailIndex(query) {
  return request({
    url: 'Product/SaveProdutDetailIndexAsync',
    method: 'post',
    params: query
  });
}
function getTempCompanyExhibitDetails(query) {
  return request({
    url: 'Product/GetTempCompanyExhibitDetails',
    method: 'post',
    params: query
  });
}

// function saveProdutCatalogDetail(query) {
//   return request.post('Product/SaveProdutCatalogDetailAsync', query)
//   .then(res => {
//     return res;
//   });
// }
// function submitProdutCatalogDetail(query){
//   return request.post('Product/SubmitProdutCatalogDetailAsync', query)
//   .then(res => {
//     return res;
//   });
// }
function saveProdutCatalogDetail(query) {
  return request.post('Product/SaveProdutCatalogDetailAsync', query)
  .then(res => {
    return res;
  });
}
function submitProdutCatalogDetail(query){
  return request.post('Product/SubmitProdutCatalogDetailAsync', query)
  .then(res => {
    return res;
  });
}


function deleteProdutCatalogDetail(query){
  return request({
    url:'Product/DeleteProdutCatalogDetailAsync',
    method:'post',
    params:query
  });
}

function saveProdutCatalogDetailIndex(query) {
  return request({
    url: 'Product/SaveProdutCatalogDetailIndexAsync',
    method: 'post',
    params: query
  });
}

function GetMstTag(query) {
  return request({
    url: 'Product/GetMstTagAsync',
    method: 'get',
    params: query
  });
}

function GetMutipleMstKeyValueMapping(query){
  return request({
    url:'Product/GetMutipleMstKeyValueMappingAsync',
    method: 'get',
    params: query
  });
}

function GetMstKeyValueMapping(query){
  return request({
    url:'Product/GetMstKeyValueMappingAsync',
    method: 'get',
    params: query
  });
}
function GetCountryProvCityArea(query){
  return request({
    url:'Product/GetCountryProvCityAreaAsync',
    method: 'get',
    params: query
  });
}
function createProdutDetailIndex(query){
  return request({
    url:'Product/CreateProdutAsync',
    method:'post',
    params:query
  });
}
function GetProducWithImage(query){
  return request({
    url:'Product/GetProducWithImage',
    method:'post',
    params:query
  });
}

// function saveProdutAsync(query){
//   return request.post('Product/SaveProdutAsync', query)
//   .then(res => {
//     return res;
//   });
// }
function saveProdutAsync(query){
  return request.post('Product/SaveProdutAsync', query)
  .then(res => {
    return res;
  });
}

// function submitProdutAsync(query){
//   return request.post('Product/SubmitProdutAsync', query)
//   .then(res => {
//     return res;
//   });
// }

function submitProdutAsync(query){
  return request.post('Product/SubmitProdutAsync', query)
  .then(res => {
    return res;
  });
}

function getExhibitCatalogById(query){
  return request({
    url:'Product/GetExhibitCatalogByIdAsync',
    method:'get',
    params:query
  });
}
/*
删除产品
*/
function deleteCompanyExhibitDetails(query){
  // return request.post("Product/DeleteCompanyExhibitDetails", query)
  // .then(res => {
  //   return res;
  // })
  return request({
    url:'Product/DeleteCompanyExhibitDetails',
    method:'post',
    params:query
  });
}
/*
获取其他信息
*/
function GetOtherInfo(query){
  return request({
    url:'Product/GetOtherInfo',
    method:'post',
    params:query
  });
}

function getSysAccountPaymentInfo(query){
  return request({
    url:'EMPBackend/GetSysAccountPaymentInfo',
    method:'post',
    params:query
  });
}

function checkSysAccountPaymentInfo(query){
  return request({
    url:'EMPBackend/CheckSysAccountPaymentInfo',
    method:'post',
    params:query
  });
}

function getSysAccountAdInfo(query){
  return request({
    url:'EMPBackend/GetSysAccountAdInfo',
    method:'post',
    params:query
  });
}

function GetProductMainProdCount(query){
  return request({
    url:'Product/GetProductMainProdCount',
    method:'post',
    params:query
  });
}
function GetIndustryByCompanyId(query){
  return request({
    url:'Product/GetIndustryByCompanyId',
    method:'post',
    params:query
  });
}

function GetProductCatByCompanyId(query){
  return request({
    url:'Product/GetProductCatByCompanyId',
    method:'post',
    params:query
  });
}

function UpdateProductMainProd(query){
  return request({
    url:'Product/UpdateProductMainProd',
    method:'post',
    params:query
  });
}

function CheckProductBeforeDelete(query){
  return request({
    url:'Product/CheckProductBeforeDelete',
    method:'post',
    params:query
  });
}

function UpdateAdsDisplay(query){
  return request({
    url:'Product/UpdateAdsDisplay',
    method:'post',
    params:query
  });


}
function GetAdSearchKeyword(query){
  return request({
    url:'Product/GetAdSearchKeyword',
    method:'get',
    params:query
  })
}

function GetCompanyAdSearchTerm(query){
  return request({
    url:'Product/GetCompanyAdSearchTerm',
    method:'get',
    params:query
  })
}

function SumbitVisitorGuide(query){
  return request({
    url:'Product/SumbitVisitorGuide',
    method:'post',
    params:query
  })
}

function GetUserVisitorGuie(query){
  return request({
    url:'Product/GetUserVisitorGuie',
    method:'post',
    params:query
  })
}

//#region 新产品中心api
function GetProductBasicInfo(query){
  return request({
    url:'Product/GetBasicInfo',
    method:'post',
    params:query
  })
}
function SaveProductBasicInfo(data){
  return request({
    url:'Product/SaveBasicInfo', 
    method:'post',
    data:data
})
}
function GetProductInfoStatus(query){
  return request({
    url:'Product/GetProductInfoStatus',
    method:'get',
    params:query
  })
} 

function GetCatalogueBuyDownloads(query){
  return request({
    url:'Product/GetCatalogueBuyDownloads',
    method:'get',
    params:query
  })
} 

function GetProductInfoProgress(query){
  return request({
    url:'Product/GetProductInfoProgress',
    method:'get',
    params:query
  })
} 

function GetProductInToFiledList(query){
  return request({
    url:'Product/GetProductInfoUnfilledFiledList',
    method:'get',
    params:query
  })
}
function GetPricingAndTradeInfo(query){
  return request({
    url:'Product/GetPricingAndTradeInfo',
    method:'get',
    params:query
  })
} 

function GetProductDetail(query){
  return request({
    url:'Product/GetProductDetail',
    method:'get',
    params:query
  })
} 

function GetProductTag(query){
  return request({
    url:'Product/GetProductTag',
    method:'get',
    params:query
  })
} 

function SavePricingAndTradeInfo(data){
  return request({
    url:'Product/SavePricingAndTradeInfo',
    method:'post',
    data:data
  })
}

function SaveProductDetail(data){
  return request({
    url:'Product/SaveProductDetail',
    method:'post',
    data:data
  })
}

function SaveProductTag(data){
  return request({
    url:'Product/SaveProductTag',
    method:'post',
    data:data
  })
}


function DelistProduct(query){
  return request({
    url:'Product/DelistProduct',
    method:'get',
    params:query
  })
} 
function DelistProductCatalog(query){
  return request({
    url:'Product/DelistProductCatalogue',
    method:'get',
    params:query
  })
} 

function GetProductList(query){
  return request({
    url:'Product/GetProductList',
    method:'get',
    params:query
  })
} 


function GetProductCatalogueById(query){
  return request({
    url:'Product/GetProductCatalogueById',
    method:'get',
    params:query
  })
} 

function SaveSubmitCatalogue(data){
  return request({
    url:'Product/SaveSubmitCatalogue',
    method:'post',
    data:data
  })
}
function SaveCatalogue(data){
  return request({
    url:'Product/SaveCatalogue',
    method:'post',
    data:data
  })
}

function CatalogueDelete(query){
  return request({
    url:'Product/CatalogueDelete',
    method:'post',
    params:query
  })
}  
function ProductDelete(query){
  return request({
    url:'Product/ProductDelete',
    method:'post',
    params:query
  })
}
function BatchProductAction(data){
  return request({
    url:'Product/BatchProductAction',
    method:'post',
    data
  })
} 
function SubmitProductInfo(query){
  return request({
    url:'Product/SubmitProductInfo',
    method:'post',
    params:query
  })
}

function GetProductApprovalStatus(query){
  return request({
    url:'Product/GetProductApprovalStatus',
    method:'get',
    params:query
  })
}

function GetProductApprovalQuotaUsage(query){
  return request({
    url:'Product/GetProductApprovalQuotaUsage',
    method:'get',
    params:query
  })
}

function GetProductApprovalDetail(data){
  return request({
    url:'Product/GetProductApprovalDetail',
    method:'post',
    data
  })
}

function UpdateProductRejectReason(data){
  return request({
    url:'Product/UpdateProductRejectReason',
    method:'post',
    data
  })
}

function UpdateProductOverallRejectReason(data){
  return request({
    url:'Product/UpdateProductOverallRejectReason',
    method:'post',
    data
  })
}

function ProductApprove(data){
  return request({
    url:'Product/ProductApprove',
    method:'post',
    data
  })
}

function SyncProductToFrontEnd(data){
  return request({
    url:'Product/SyncProductToFrontEnd',
    method:'post',
    data:data
  })
}

//#endregion